import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parse } from 'qs';
import { generateShopifyAuthorizationUrl } from 'utils/adaya/ShopifyUtils';
import Constants from 'lib/Constants';

const ShopifyAuthorize = (props) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const { shop, timestamp } = parse(location.search, { ignoreQueryPrefix: true });

        // todo: Should register user with webhooks (order create and bulk job)...

        let url = generateShopifyAuthorizationUrl(shop);
        if (url) {
            window.location.href = url;
        } else {
            navigate(Constantss.DEFAULT_LOGIN_ROUTE);
        }
    }, []);

    return (
        <></>
    );

};

export default ShopifyAuthorize;